export default import.meta.ROLLDOWN_FILE_URL_GVeov1GORNcrMmND9w0OFw